import { getTemplateEditorUrl } from 'utils/appRoutes';
import { useGetTemplateResourceData } from '../hooks/useGetTemplateResourceData';
import { useGetTemplateThumbnailData } from '../hooks/useGetTemplateThumbnailData';
import { ActivityItem as ActivityItemType } from '../Launchpad.types';
import { ActivityItem } from './ActivityItem';

export const TemplateItem = (props: {
  item: ActivityItemType;
  titleWidth: number;
}) => {
  // Resource data
  const { resource, isLoading, hasError } = useGetTemplateResourceData(props.item.resourceId);
  const { id: templateId, messageMedium } = resource || {};

  // Resource url
  const url = getTemplateEditorUrl(templateId);

  // Resource thumbnail
  const { thumbnail, isThumbnailLoading } = useGetTemplateThumbnailData({
    templateId,
    messageMedium,
  });

  return (
    <ActivityItem
      {...props}
      isHidden={!templateId}
      isLoading={isLoading}
      hasError={hasError}
      resource={{ ...resource, templateId }}
      thumbnail={thumbnail}
      isThumbnailLoading={isThumbnailLoading}
      url={url}
    />
  );
};
